import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import appStoreImg from "../assets/img/app-store.png";
import googlePlayImg from "../assets/img/google.store.png";
import { trackAppStoreClick, trackGooglePlayClick } from "../analytics/googleAnalytics";
import "./DownloadRedirect.css";

// Mismo motivo que en el modal: logo ligero y QR estatico, sin pedirle nada a
// un tercero para pintar la pantalla.
const LOGO = "/assets/img/wayo-logo.webp";
const QR = "/assets/img/qr-download-page.png";
// Detección y URLs de tienda viven en utils/dispositivo.js: la barra superior de
// la landing necesita exactamente lo mismo y no puede haber dos copias.
import {
  APP_STORE_URL,
  GOOGLE_PLAY_URL,
  DOWNLOAD_URL,
  isIOS,
  isAndroid,
  getMobileStoreUrl,
} from "../utils/dispositivo";

export default function DownloadRedirect() {
  const params = new URLSearchParams(window.location.search);
  const isPreview = params.get("preview") === "1";

  // El QR se decide por ANCHO, no solo por user-agent. La deteccion de movil
  // sirve para redirigir, pero falla en navegadores dentro de apps, tablets y
  // moviles nuevos: a todos esos les salia un codigo QR que no pueden escanear
  // porque el telefono que lo mostraria es el mismo que tendria que leerlo.
  // Con el ancho no hay falso negativo posible.
  const [pantallaEstrecha, setPantallaEstrecha] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 700px)");
    const aplicar = () => setPantallaEstrecha(mq.matches);
    aplicar();
    mq.addEventListener("change", aplicar);
    return () => mq.removeEventListener("change", aplicar);
  }, []);
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || "";
  const isMobileDownload = !isPreview && (isAndroid(userAgent) || isIOS(userAgent));
  const mobileStoreUrl = getMobileStoreUrl(userAgent);
  // Nunca en un movil detectado, y nunca en una pantalla estrecha aunque el
  // user-agent diga que es un ordenador.
  const mostrarQr = !isMobileDownload && !pantallaEstrecha;

  useEffect(() => {
    if (isPreview) return;

    if (isAndroid(userAgent)) {
      window.location.replace(mobileStoreUrl);
      return;
    }

    if (isIOS(userAgent)) {
      window.location.replace(mobileStoreUrl);
    }
  }, [isPreview, mobileStoreUrl, userAgent]);

  return (
    <main className="download-page">
      <Helmet>
        <title>Descargar Wayo | App Store y Google Play</title>
        <meta
          name="description"
          content="Descarga Wayo para iPhone o Android y empieza a contar calorías con una foto."
        />
        <link rel="canonical" href={DOWNLOAD_URL} />
      </Helmet>

      <section className="download-hero" aria-labelledby="download-title">
        <div className="download-brand">
          <img src={LOGO} alt="Wayo" width="68" height="45" />
          <span>Wayo</span>
        </div>

        <div className="download-copy">
          <p className="download-eyebrow">Prueba 7 días gratis</p>
          <h1 id="download-title">
            {isMobileDownload
              ? "Abriendo la tienda..."
              : mostrarQr
                ? "Escanea y descarga Wayo"
                : "Descarga Wayo"}
          </h1>
          <p>
            {isMobileDownload
              ? "Te estamos llevando automáticamente a la tienda correcta para tu dispositivo."
              : mostrarQr
                ? "Desde ordenador, escanea el QR con tu teléfono o elige tu plataforma."
                : "Elige tu tienda y empieza en menos de un minuto."}
          </p>
        </div>

        {isMobileDownload && (
          <a className="download-fallback-button" href={mobileStoreUrl}>
            Abrir Wayo en la tienda
          </a>
        )}

        {!isMobileDownload && (
          <div className="download-panel">
            {mostrarQr && (
              <div className="download-qr">
                <img src={QR} alt="QR para descargar Wayo" width="260" height="260" />
              </div>
            )}

            <div className="download-actions" aria-label="Descargar Wayo">
              <a
                href={APP_STORE_URL}
                className="download-store-badge"
                onClick={() => trackAppStoreClick("download_page")}
              >
                <img src={appStoreImg} alt="Descargar en App Store" />
              </a>
              <a
                href={GOOGLE_PLAY_URL}
                className="download-store-badge"
                onClick={() => trackGooglePlayClick("download_page")}
              >
                <img src={googlePlayImg} alt="Disponible en Google Play" />
              </a>
            </div>
          </div>
        )}
      </section>
    </main>
  );
}
